export default __webpack_public_path__ + "static/media/image_verification.91333868.png";